const ROUTER = {
  LOGIN_GOOGLE: "/dang-nhap-tu-mang-xa-hoi",
  HOME: "/",
  SVG_VIEWER: "/svg-viewer",

  LIEN_HE: "/lien-he",

  // ADMIN
  TONG_QUAT: "/tong-quat",
  //Dịch vụ
  YEU_CAU_HO_TRO: "/yeu-cau-ho-tro",
  //Bài viết
  DANH_SACH_BAI_VIET: "/danh-sach-bai-viet",
  DANH_MUC_THE: "/danh-muc-the",
  DANG_BAI: "/dang-bai",
  //Banner

  BANNER_FOOTER: "/banner-footer",
  //quản trị
  PHAN_QUYEN: "/phan-quyen",
  CHUC_VU: "/chuc-vu",
  DANH_BA_DOANH_NGHIEP: "/danh-ba-doanh-nghiep",
  DANH_BA_NHAN_VIEN: "/danh-ba-nhan-vien",
  DANH_BA_GIAO_VIEN: "/danh-ba-giao-vien",
  DANH_BA_TRUONG_HOC: "/danh-ba-truong-hoc",
  THONG_KE_TONG_QUAN: "/thong-ke-tong-quan",
  THONG_KE_CHI_TIET: "/thong-ke-chi-tiet",
  KY_NANG: "/ky-nang",

  //Khóa học
  QUAN_LY_KHOA_HOC: "/quan-ly-khoa-hoc",
  QUAN_LY_BAI_GIANG: "/quan-ly-bai-giang",
  DANH_BA: "/danh-ba",

  //Ngân hàng đề
  DANH_SACH_DE_THI: "/danh-sach-de-thi",
  NGAN_HANG_CAU_HOI: "/ngan-hang-cau-hoi",
  DANH_MUC_THE_NGAN_HANG_DE: "/danh-sach-the-ngan-hang",
  // Hồ sơ lý lịch

  //User
  GIO_HANG: "/gio-hang",
  //Dashboard
  TONG_QUAN: "/tong-quan",
  DANH_SACH_KHOA_HOC: "/danh-sach-khoa-hoc",
  DANH_SACH_HOC_VIEN: "/danh-sach-hoc-vien",

  Tim_KIEM_KHOA_HOC: "/tim-kiem",
  CHI_TIET_KHOA_HOC: "/chi-tiet-khoa-hoc",
  VAO_HOC: "/vao-hoc",
  //HOC_VIEN
  HO_SO_CUA_TOI: "/ho-so-cua-toi",

  //Tin tức
  DANH_SACH_TIN_TUC: "/danh-sach-tin-tuc",
  TIN_TUC: "/tin-tuc",
  TIM_KIEM_TIN_TUC: "/tim-kiem-tin-tuc",
  //Giáo viên
  DANH_SACH_GIAO_VIEN: "/danh-sach-giao-vien",
  THONG_TIN_GIAO_VIEN: "/thong-tin-giao-vien",
}
export default ROUTER
